import { createClient } from '@lumi.new/sdk'

export const lumi = createClient({
  projectId: 'p410083387467890688',
  apiBaseUrl: 'https://api.lumi.new',
  authOrigin: 'https://auth.lumi.new',
})
